/**
 * Utility functions for scheduled message functionality
 */

/**
 * Format a scheduled message time for display
 * @param {string} scheduledSendAt - ISO date string
 * @param {string} timezone - Building timezone (optional)
 * @param {object} options - Additional formatting options
 * @returns {string} Formatted time string
 */
export const formatScheduledTime = (scheduledSendAt, timezone = 'America/New_York', options = {}) => {
  if (!scheduledSendAt) return ''

  const date = new Date(scheduledSendAt)
  return date.toLocaleString('en-US', {
    timeZone: timezone,
    weekday: options.includeWeekday ? 'short' : undefined,
    month: 'short',
    day: 'numeric',
    year: options.includeYear ? 'numeric' : undefined,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    ...options.customFormat
  })
}

/**
 * Generate time slot options in specified intervals
 * @param {number} intervalMinutes - Minutes between each time slot (default 5)
 * @returns {Array} Array of time slot options with label and value
 */
export const generateTimeSlots = (intervalMinutes = 5) => {
  const slots = []
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += intervalMinutes) {
      const time = new Date()
      time.setHours(hour, minute, 0, 0)
      const timeString = time.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      })
      slots.push({
        label: timeString,
        value: time.toISOString()
      })
    }
  }
  return slots
}
